import { Component, Input, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import Swal from 'sweetalert2';
import { SsoUserDto } from '../dto/sso-user.dto';
import { UserApiService } from '../services/user-api.service';
import { directionsAT } from '../directions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() translation: any;
  @Input() unreadCount: number = 0;

  @Input() userData: SsoUserDto | undefined;

  myAvatar: string | undefined;

  myManagers: {
    cn: string,
    displayName: string,
    sn: string,
    givenName: string,
    mail: string,
    careerTitle: string,
  }[] | undefined;
  myDirectManager: {
    cn: string,
    displayName: string,
    sn: string,
    givenName: string,
    mail: string,
    careerTitle: string,
  } | undefined;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private userApiService: UserApiService
  ) { }

  ngOnInit(): void {

    this.userApiService.getMyAvatar().subscribe({
      next: (avatar) => {
        if (avatar && avatar.data) {
          this.myAvatar = this.arrayBufferToBase64(avatar.data);
        }
      },
      error: (error) => {
        console.error('Error getting my avatar: ', error);
      }
    });

    this.userApiService.getMyManagers().subscribe({
      next: (managers) => {
        if (managers) {
          this.myManagers = managers;
        }
      },
      error: (error) => {
        console.error('Error getting my managers: ', error);
      }
    });

    this.userApiService.getMyDirectManager().subscribe({
      next: (directManager) => {
        if (directManager) {
          this.myDirectManager = directManager;
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  openHRPopup(): void {
    let html = ``;
    if (this.userData!.country === 'HU' || this.userData!.preferredLanguage === 'hungarian') {
      html = `<strong>${this.translation.contact_hr}:</strong><br><br>
            <p>Email: <a href="mailto:regisztracio@efs-zrt.hu">regisztracio@efs-zrt.hu</a></p>
            <p>Telefon: <a href="tel:+36703863659">+36703863659</a></p>
            <p>Munkaórák: <strong>08:00-16:30</strong></p>
          `;
    } else {
      html = `
      <strong>${this.translation.contact_hr}:</strong><br><br>
      <p>Email: <a href="mailto:personalabteilung@efs-ag.de">personalabteilung@efs-ag.de</a></p>
      <p>Telefon: <a href="tel:+4961315838895">+49 6131 58388-95</a></p>
    `;
    }

    Swal.fire({
      html: html,
      confirmButtonColor: '#1f2c50',
      confirmButtonText: this.translation.back,
    })
  }

  openContractPopup(): void {
    let html = ``;

    
    let country = this.userData!.country;

    if (this.userData!.preferredLanguage && this.userData!.preferredLanguage === 'austria') {
      country = 'AT';
    } else if (this.userData!.preferredLanguage && this.userData!.preferredLanguage === 'german') {
      country = 'DE';
    } else if (this.userData!.preferredLanguage && this.userData!.preferredLanguage === 'hungarian') {
      country = 'HU';
    }


    if (country === 'AT') {
      const myFirstDirector = this.myDirectManager ? this.myDirectManager : undefined;

      if (!myFirstDirector) {
        html = `
            <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:antrag-at@efs-ag.de">antrag-at@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538854">+49 6131 58388-54</a></p>
            <br>
            <strong>Wertpapierabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538854">+49 6131 58388-54</a></p>
          `;
      } else {
        // Show details for myFirstDirector
        const matchingContractMailBox = directionsAT.find(director => director.cn === myFirstDirector.cn);
        if (matchingContractMailBox) {
          // Show details for matchingContractMailBox
          html = `
          <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <strong>Direktion ${myFirstDirector.displayName}</strong><br>
            <p>Email: <a href="mailto:${matchingContractMailBox.directorContractMailBox}">${matchingContractMailBox.directorContractMailBox}</a></p>
            <br>
            <strong>Wertpapierabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538854">+49 6131 58388-54</a></p>
          `;
        } else {
          html = `
            <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:antrag-at@efs-ag.de">antrag-at@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538854">+49 6131 58388-54</a></p>
            <br>
            <strong>Wertpapierabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538854">+49 6131 58388-54</a></p>
          `;
        }
      }
    } else if (country === 'DE') {
      const myFirstDirector = this.myDirectManager ? this.myDirectManager : undefined;

      if (!myFirstDirector) {
        html = `
            <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:antrag@efs-ag.de">antrag@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538850">+49 6131 58388-50</a></p>
          `;
      } else {
        // Show details for myFirstDirector
        const matchingContractMailBox = directionsAT.find(director => director.cn === myFirstDirector.cn);
        if (matchingContractMailBox) {
          // Show details for matchingContractMailBox
          html = `
            <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <strong>Direktion ${myFirstDirector.displayName}</strong><br>
            <p>Email: <a href="mailto:${matchingContractMailBox.directorContractMailBox}">${matchingContractMailBox.directorContractMailBox}</a></p>
          `;
        } else {
          html = `
            <strong>Antragsabteilung kontaktieren:</strong><br><br>
            <p>Email: <a href="mailto:antrag@efs-ag.de">antrag@efs-ag.de</a></p>
            <p>Telefon: <a href="tel:+4961318538850">+49 6131 58388-50</a></p>
          `;
        }
      }
    } else if (country === 'HU') {
      html = `
            <strong>Antrags érintkezés:</strong><br><br>
            <p>Email: <a href="mailto:office@efs-zrt.hu">office@efs-zrt.hu</a></p>
            <p>Telefon: <a href="tel:+36709451624">+36709451624</a></p>
            <p>Munkaórák: <strong>08:00-16:30</strong></p>
          `;
    } else {
      html = `Die Kontaktinformation konnte für deinen Account nicht gefunden werden. Wende dich an den EFS-IT-Support: <a href="mailto:support@efs-ag.com">support@efs-ag.com</a>`;
    }

    Swal.fire({
      html: html,
      confirmButtonColor: '#1f2c50',
      confirmButtonText: this.translation.back,
    })
  }

  openSupportPopup(): void {
    if (this.userData!.country === 'HU' || this.userData!.preferredLanguage === 'hungarian') {
      Swal.fire({
        title: this.translation.contact_support,
        html: `
        <p>Email: <a href="mailto:support@efs-zrt.hu">support@efs-zrt.hu</a></p>
        <p>Telefon: <a href="tel:+36704278126">+36 70 427 8126</a></p>
        <p>Munkaórák: <strong>08:00-17:00</strong></p>
        `,
        confirmButtonColor: '#1f2c50',
        confirmButtonText: this.translation.back,
      })
    } else {
      window.open('https://support.efs-ag.com', '_blank');
    }
  }

  logout(): void {
    Swal.fire({
      title: this.translation.logout,
      text: this.translation.logout_question,
      showDenyButton: true,
      confirmButtonColor: '#1f2c50',
      confirmButtonText: this.translation.logout_yes,
      denyButtonText: this.translation.logout_no,
    }).then((result) => {
      if (result.isConfirmed) {
        this.oidcSecurityService.getEndSessionUrl().subscribe((url) => {
          if (url) {
            sessionStorage.clear();
            window.location.href = url;
          }
        });
      }
    });
  }

  arrayBufferToBase64(buffer: any) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}
